/**
 * Created by rak on 7/06/2019.
 */
(function () {
  'use strict';

  angular
    .module('betosyswebapp')
    .directive('loadingAnimation', function () {
      return {
        restrict: 'E',
        templateUrl: 'components/common/directives/loadingAnimationDirective.tpl.html',
        replace: true
      };
    });
})();



// WEBPACK FOOTER //
// ./.tmp/components/common/directives/loadingAnimationDirective.js